/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Roles/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'



/** @type {import('Simple/types.js').View} */
export default function Roles({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/NewAddress/Content/NewRelation/Add/Content/Relationship/Roles",
  isInvalid,
  onChange
  
}) {
let rolesValueData = fromData.useDataValue({ viewPath,
context: 'roles',
})
let newRelationRelationshipRoleValueData = fromData.useDataValue({ viewPath,
context: 'new_relation',
path: 'relationship.role',
})
let newRelationRelationshipRoleIsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_relation',
path: 'relationship.role',
validate: fromValidate.text,
required: true,
})
let newRelationRelationshipRoleChangeData = fromData.useDataChange({ viewPath,
context: 'new_relation',
path: 'relationship.role',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 marginLeft={dtSpaceS}
 maxWidth={180}
 data="roles"
 from={rolesValueData}
 data="new_relation.relationship.role"
 validate="/Data/validate.js text"
 invalid={!newRelationRelationshipRoleIsValidData}
 required={true}
 value={newRelationRelationshipRoleValueData}
 onChange={newRelationRelationshipRoleChangeData}
>
{childProps => (
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}